




































import { IUser } from '@/models';
import { getPropertyFromItem } from '@/utils/helpers';
import Vue, { PropType, VNodeChildren } from 'vue';
import { SelectItemKey } from 'vuetify';
import VNodes from '../computation/VNodes.vue';
interface IMaskedCharactersOutput {
  start: string;
  middle: string;
  end: string;
}

export default Vue.extend({
  name: 'MentionMenuList',

  components: { VNodes },

  props: {
    mentionableUsers: {
      type: Array as PropType<IUser[]>
    },

    itemDisabled: {
      type: [String, Array, Function] as PropType<SelectItemKey>,
      default: 'disabled'
    },

    mentionItemText: {
      type: [String, Array, Function] as PropType<SelectItemKey>,
      default: 'text'
    },

    searchInput: String,
    noDataText: String,
    noFilter: Boolean,
    loading: Boolean
  },

  methods: {
    onMentionClick(user: IUser) {
      if (!this.getDisabled(user)) this.$emit('select', user);
    },

    getMaskedCharacters(text: string): IMaskedCharactersOutput {
      const searchInput = (this.searchInput || '')
        .toString()
        .toLocaleLowerCase();
      const index = text.toLocaleLowerCase().indexOf(searchInput);

      const maskedCharacters = { start: text, middle: '', end: '' };

      if (index < 0) return maskedCharacters;

      maskedCharacters.start = text.slice(0, index);
      maskedCharacters.middle = text.slice(index, index + searchInput.length);
      maskedCharacters.end = text.slice(index + searchInput.length);
      return maskedCharacters;
    },

    genFilteredText(text: string): VNodeChildren {
      if (!this.searchInput || this.noFilter) return text;

      const { start, middle, end } = this.getMaskedCharacters(text);

      return [start, this.genHighlight(middle), end];
    },

    genHighlight(text: string) {
      return this.$createElement(
        'span',
        { staticClass: 'v-list-item__mask' },
        text
      );
    },

    genListTileTitleText(text: string) {
      return this.$createElement('v-list-item-title', [
        this.genFilteredText(text)
      ]);
    },

    getDisabled(item: IUser): boolean {
      return Boolean(getPropertyFromItem(item, this.itemDisabled, false));
    },

    getText(item: IUser): string {
      return String(getPropertyFromItem(item, this.mentionItemText, item));
    }
  }
});
